import { render, staticRenderFns } from "./PersistResponsavelWebhookView.vue?vue&type=template&id=efe2456e&"
import script from "./PersistResponsavelWebhookView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponsavelWebhookView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports